// BidTurns purchase-intent + product-ad API — called via our own backend
// proxy at test.astropanditji.org/api/bidturns/chat.
//
// Why proxied: ad-blockers pattern-match hostnames containing "bid" /
// "ads" and silently drop the request. Routing through our own domain
// dodges those blocklists and keeps the publisher API key on the server.

// Same-origin: hits the /api/* behavior on the sutrumai.com CloudFront
// distribution which routes to the dedicated DeepAI Lambda.
const API_BASE = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');

const PROXY_URL = `${API_BASE}/api/bidturns/chat`;
const CLIENT_ID = 'deepai-web';

export function newSessionId() {
  const rand = Math.random().toString(36).slice(2, 10);
  return `da-${Date.now().toString(36)}-${rand}`;
}

/**
 * Analyze one user message for purchase intent. Never throws — returns
 * null on failure so the chat continues to work even if BidTurns is down.
 */
export async function bidturnsAnalyze({ query, sessionId, signal } = {}) {
  if (!query || !sessionId) return null;
  try {
    const res = await fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query, sessionid: sessionId, clientid: CLIENT_ID }),
      signal,
    });
    if (!res.ok) return null;
    const data = await res.json().catch(() => null);
    if (!data) return null;
    return {
      intent: data.intent || null,
      adData: data.ad_data || null,
      latency: typeof data.latency === 'number' ? data.latency : null,
    };
  } catch {
    return null;
  }
}
